import { CSSProperties } from 'react';

import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum QuestionIconVariant {
  DEFAULT = 'default',
  DISABLED = 'disabled',
}
interface IQuestionIconProps extends IConDefaultType {
  variant?: QuestionIconVariant;
  style?: CSSProperties;
}

function QuestionIcon({
  color,
  className,
  rotate,
  flip,
  variant = QuestionIconVariant.DEFAULT,
  style,
}: IQuestionIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === QuestionIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
          <g filter="url(#filter0_d_10762_427935)">
            <path
              d="M50 25C50 36.0457 41.0457 45 30 45C18.9543 45 10 36.0457 10 25C10 13.9543 18.9543 5 30 5C41.0457 5 50 13.9543 50 25Z"
              fill="#FDFDFE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.2254 19.4136C28.8362 19.0546 29.5543 18.9234 30.2526 19.0432C30.9509 19.163 31.5842 19.526 32.0405 20.068C32.4967 20.61 32.7465 21.296 32.7454 22.0045L32.7454 22.0067C32.7454 22.7104 32.1978 23.444 31.1634 24.1336C30.6918 24.448 30.2096 24.6902 29.8393 24.8547C29.6563 24.9361 29.5059 24.9961 29.4048 25.0347C29.3543 25.0539 29.3165 25.0676 29.2934 25.0758L29.2703 25.0839L29.27 25.084L29.2696 25.0842L29.2685 25.0845L29.2679 25.0847C28.484 25.3479 28.0608 26.1962 28.3224 26.9811C28.5844 27.767 29.4338 28.1917 30.2198 27.9297L29.7454 26.5067C30.2198 27.9297 30.2202 27.9296 30.2206 27.9294L30.2216 27.9291L30.2239 27.9283L30.2298 27.9264L30.2464 27.9207C30.2596 27.9162 30.277 27.9101 30.2985 27.9025C30.3413 27.8872 30.4002 27.8658 30.4728 27.8381C30.6177 27.7829 30.8189 27.7024 31.0577 27.5962C31.5312 27.3857 32.174 27.0654 32.8275 26.6298C34.0429 25.8195 35.745 24.3034 35.7454 22.0076L35.7454 22.009L34.2456 22.0067H35.7454V22.0076C35.7472 20.5911 35.2478 19.2197 34.3356 18.136C33.423 17.052 32.1563 16.3259 30.7598 16.0864C29.3632 15.8468 27.9269 16.1093 26.7053 16.8272C25.4837 17.5452 24.5556 18.6723 24.0854 20.009C23.8105 20.7904 24.2212 21.6468 25.0026 21.9217C25.7841 22.1966 26.6405 21.786 26.9154 21.0045C27.1505 20.3361 27.6146 19.7726 28.2254 19.4136ZM29.8654 31.0067C29.037 31.0067 28.3654 31.6783 28.3654 32.5067C28.3654 33.3351 29.037 34.0067 29.8654 34.0067H29.8804C30.7088 34.0067 31.3804 33.3351 31.3804 32.5067C31.3804 31.6783 30.7088 31.0067 29.8804 31.0067H29.8654Z"
              fill="#8A8A8A"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_10762_427935"
              x="0"
              y="0"
              width="60"
              height="60"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5" />
              <feGaussianBlur stdDeviation="5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.453613 0 0 0 0 0.453613 0 0 0 0 0.453613 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10762_427935" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10762_427935" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === QuestionIconVariant.DISABLED && (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
          <g opacity="0.5" filter="url(#filter0_d_10859_214734)">
            <path
              d="M50 25C50 36.0457 41.0457 45 30 45C18.9543 45 10 36.0457 10 25C10 13.9543 18.9543 5 30 5C41.0457 5 50 13.9543 50 25Z"
              fill="#FDFDFE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.2254 19.4136C28.8362 19.0546 29.5543 18.9234 30.2526 19.0432C30.9509 19.163 31.5842 19.526 32.0405 20.068C32.4967 20.61 32.7465 21.296 32.7454 22.0045L32.7454 22.0067C32.7454 22.7104 32.1978 23.444 31.1634 24.1336C30.6918 24.448 30.2096 24.6902 29.8393 24.8547C29.6563 24.9361 29.5059 24.9961 29.4048 25.0347C29.3543 25.0539 29.3165 25.0676 29.2934 25.0758L29.2703 25.0839L29.27 25.084L29.2696 25.0842L29.2685 25.0845L29.2679 25.0847C28.484 25.3479 28.0608 26.1962 28.3224 26.9811C28.5844 27.767 29.4338 28.1917 30.2198 27.9297L29.7454 26.5067C30.2198 27.9297 30.2202 27.9296 30.2206 27.9294L30.2216 27.9291L30.2239 27.9283L30.2298 27.9264L30.2464 27.9207C30.2596 27.9162 30.277 27.9101 30.2985 27.9025C30.3413 27.8872 30.4002 27.8658 30.4728 27.8381C30.6177 27.7829 30.8189 27.7024 31.0577 27.5962C31.5312 27.3857 32.174 27.0654 32.8275 26.6298C34.0429 25.8195 35.745 24.3034 35.7454 22.0076L35.7454 22.009L34.2456 22.0067H35.7454V22.0076C35.7472 20.5911 35.2478 19.2197 34.3356 18.136C33.423 17.052 32.1563 16.3259 30.7598 16.0864C29.3632 15.8468 27.9269 16.1093 26.7053 16.8272C25.4837 17.5452 24.5556 18.6723 24.0854 20.009C23.8105 20.7904 24.2212 21.6468 25.0026 21.9217C25.7841 22.1966 26.6405 21.786 26.9154 21.0045C27.1505 20.3361 27.6146 19.7726 28.2254 19.4136ZM29.8654 31.0067C29.037 31.0067 28.3654 31.6783 28.3654 32.5067C28.3654 33.3351 29.037 34.0067 29.8654 34.0067H29.8804C30.7088 34.0067 31.3804 33.3351 31.3804 32.5067C31.3804 31.6783 30.7088 31.0067 29.8804 31.0067H29.8654Z"
              fill="#8A8A8A"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_10859_214734"
              x="0"
              y="0"
              width="60"
              height="60"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5" />
              <feGaussianBlur stdDeviation="5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.453613 0 0 0 0 0.453613 0 0 0 0 0.453613 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10859_214734" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10859_214734" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default QuestionIcon;
